import "./Package.css";

import { Breadcrumb, message, Table, type TableColumnsType, Tag } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { SectionHeader, TableMenuDropdown } from "../../_lib/_components";
import { type PackageType, useAppSelector } from "../../_lib/_store";
import {
  deletePackage,
  getPackages,
} from "../../_lib/_store/services/packageService";

export const PackagePage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, packages } = useAppSelector((state) => state.package);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getPackages(messageApi);
  };

  const columns: TableColumnsType<PackageType> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Tags",
      dataIndex: "tags",
      key: "tags",
      render: (tags: string[]) =>
        tags.map((tag, index) => <Tag key={index}>{tag}</Tag>),
    },
    {
      title: "Package Type",
      dataIndex: "packageType",
      key: "packageType",
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: PackageType) => {
    switch (key) {
      case "show":
        navigate(`/package/show`, { state: { package: obj } });
        break;
      case "edit":
        navigate(`/package/edit`, { state: { package: obj } });
        break;
      case "delete":
        deletePackage(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="package">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: "Package",
            },
          ]}
        />
        <SectionHeader dataLength={packages.length} createRoute="package" />
        <Table
          sticky
          dataSource={packages}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1000 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
